import { CardBody } from "reactstrap";
import styled from "styled-components";

const ScrollCardBody = styled(CardBody)`
  overflow-y: scroll;
  max-height: ${props => (props.maxheight ? props.maxheight : "200px")};
`;

export default ScrollCardBody;
